// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyGetFieldsWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyGetFieldsRequestDto,
  UserPropertyGetFieldsResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetPropertyFieldsParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields_Args {
  getParams: GetPropertyFieldsParams;
  postData: UserPropertyGetFieldsRequestDto;
}

export type RentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields_Options = UseMutationOptions<
  UserPropertyGetFieldsResponseWebDto,
  unknown,
  RentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields_Args
>;

/**
 * Infer rental property listing fields for an existing manual listing
 * @deprecated
 */
export const useRentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields_Args) =>
      RentalManagerUserPropertyGetFieldsWebApiHandler_getPropertyFields(args.getParams, args.postData, httpClient),
  });
};
